// src/components/CarouselLogo.jsx
import React from "react";
import { logos } from "../Constants";

const CarouselLogo = () => {
  const repeatedLogos = logos.concat(logos); 
  return (
    <div className="py-5 relative overflow-hidden">

      <div className="absolute top-0 left-0 right-0 h-full bg-[#14171d]" />

      {/* Línea superior */}
      <div className="absolute top-0 left-0 w-full h-px bg-gray-600 z-30" />

      {/* Línea inferior */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gray-600 z-30" />

      <div className="relative w-full z-20">
        {/* Texto encima del carrusel */}
        <h3 className="text-center text-sm sm:text-base md:text-xl lg:text-2xl font-bold text-white mb-6 mt-2 max-w-full px-4">
          Algunas herramientas y tecnologías que utilizamos
        </h3>

        {/* Carrusel de logos */}
        <div className="relative w-full">
          {/* Contenedores laterales*/}
          <div className="absolute top-0 left-0 w-1/6 h-full bg-[#14171d] blur-4xl z-50" />
          <div className="absolute top-0 right-0 w-1/6 h-full bg-[#14171d] blur-4xl z-50" />

          {/* Carrusel */}
          <div className="animate-marquee flex gap-12 w-max">
            {repeatedLogos.map((logo, i) => (
              <img
                key={i}
                src={logo}
                alt="logo"
                className="h-12 md:h-14 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarouselLogo;
